<div class="container px-0">
    <app-casa-personal-profile-form
            [personDetails]="personDetails"
            [sensitiveDetails]="sensitiveDetails"
            [settings]="settings"
            [address]="address"
            [photo]="photo"
            [contacts]="contacts"
            (savePersonDetails)="savePersonDetails($event)"
            (saveSensitiveDetails)="saveSensitiveDetails($event)"
            (saveSettings)="saveSettings($event)"
            (saveAddress)="saveAddress($event)"
            (saveContacts)="saveContacts($event)"
            (savePhoto)="savePhoto($event)"
            [busy]="activeSubscriptions > 0"
    ></app-casa-personal-profile-form>
</div>
